export default __webpack_public_path__ + "static/iconography-image-l-66d6a22bffe0a890ae8970b1af5ca92e.png";